import React, { useEffect, useMemo, useState, useReducer } from 'react';
import { withTranslation } from 'react-i18next';
import TableContainer from '../../Components/Common/TableContainer';
import { formatCurrency, formatDate } from '../../helpers/format';
import { useDispatch } from 'react-redux';
import { Can } from '../../helpers/casl';
import { getCustomerReserves } from '../../slices/customers/thunk';
import EditOrderDropdown from '../OrdersManagement/components/EditOrderDropdown';
import ApproveOrder from '../OrdersManagement/components/ApproveOrder';
import CancelOrder from '../OrdersManagement/components/CancelOrder';
import { ToastContainer } from 'react-toastify';

const Reserves = ({ document, setLoading, isLoading, t }) => {
  const dispatch = useDispatch();
  const [selectedOrder, setSelectedOrder] = useState(null);

  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [meta, setMeta] = useState({});

  const getData = async () => {
    setLoading(true);
    const order = 'desc';
    const response = await dispatch(
      getCustomerReserves({ page, order, filters: { document: { eq: document } } })
    );
    setLoading(false);

    if (response?.error) {
      return;
    }

    const payload = response.payload;

    setData(payload.data);
    setMeta(payload.meta);
  };

  useEffect(() => {
    getData();
  }, [dispatch, page]);

  const translations = {
    liquidated: {
      label: t(`reserve-management.status-liquidated`),
      color: 'bg-success-subtle text-success',
    },

    reversed: {
      label: t(`reserve-management.status-reversed`),
      color: 'bg-warning-subtle text-warning',
    },

    active: {
      label: t(`reserve-management.status-active`),
      color: 'bg-success-subtle text-success',
    },

    inactive: {
      label: t(`reserve-management.status-inactive`),
      color: 'bg-danger-subtle text-danger',
    },
  };

  const getTranslationStatus = (status) => {
    return translations[status] ?? {
      label: 'Não mapeado',
      color: 'esquecémo-dinuevo'
    };
  };

  const columns = useMemo(
    () => [
      {
        Header: t('type'),
        accessor: 'type',
        filterable: false,
        Cell: (props) => t(props.row.original.identifier_type),
      },
      {
        Header: t('ticket'),
        accessor: 'ticket',
        filterable: false,
        Cell: (props) => t(props.row.original.ticket),
      },
      {
        Header: t('order-total'),
        accessor: 'total',
        filterable: false,
        Cell: (props) => formatCurrency(props.row.original.value),
      },
      {
        Header: t('wallets.filters.status'),
        accessor: 'status',
        filterable: false,
        Cell: (props) => {
          const translation = getTranslationStatus(
            props.row.original.status
          );

          return (
            <React.Fragment>
              <span className={`badge rounded-pill ${translation?.color}`}>
                {translation?.label}
              </span>
            </React.Fragment>
          );
        },
      },
      {
        Header: t('created-at'),
        accessor: 'created_at',
        filterable: false,
        Cell: (props) => formatDate(props.row.original.created_at),
      },
    ],
    []
  );

  return (
    <React.Fragment>
      <TableContainer
        isLoading={isLoading}
        columns={columns}
        data={data || []}
        activePage={page}
        pageSize={meta?.take || 10}
        totalPages={meta?.pages || 0}
        count={meta?.total || 0}
        setPage={setPage}
        className="custom-header-css"
        divClass="table-responsive table-card mb-0"
        tableClass="align-middle table-nowrap"
        theadClass="table-light"
      />
      <ToastContainer position="top-center" closeButton={false} limit={1} />
    </React.Fragment>
  );
};

export default withTranslation()(Reserves);
